import api from './api';

const base = '/api/warmup';

export async function fetchWarmupEntitlements() {
  const { data } = await api.get(`${base}/entitlements`);
  return data;
}

export async function listWarmupAccounts() {
  const { data } = await api.get(`${base}/accounts`);
  return data;
}

export async function enableWarmup(provider, accountEmail, names = {}) {
  const { data } = await api.post(`${base}/enable`, {
    provider,
    account_email: accountEmail,
    sender_first: names.senderFirst || undefined,
    sender_last: names.senderLast || undefined,
  });
  return data;
}

export async function disableWarmup(provider, accountEmail) {
  const { data } = await api.post(`${base}/disable`, {
    provider,
    account_email: accountEmail,
  });
  return data;
}

export async function getWarmupStatus(provider, accountEmail) {
  const { data } = await api.get(`${base}/status`, {
    params: { provider, account_email: accountEmail },
  });
  return data;
}

export async function getWarmupMetrics(provider, accountEmail, timeFrom, timeTo) {
  const { data } = await api.get(`${base}/metrics`, {
    params: {
      provider,
      account_email: accountEmail,
      time_from: timeFrom,
      time_to: timeTo,
    },
  });
  return data;
}

export async function startEmailWarmingCheckout(quantity = 1) {
  const origin = window.location.origin;
  const { data } = await api.post('/api/payments/email-warming/checkout', {
    quantity,
    success_url: `${origin}/outbound-setup?warming_checkout=success`,
    cancel_url: `${origin}/outbound-setup?warming_checkout=cancel`,
  });
  return data;
}
